import React from 'react'
import Navbar from '../navbar/navbar'
import Services from '../services/service'
const Servicespage = () => {
  return (
    <div>
      <Navbar/>
      <Services/>
    </div>
  )
}

export default Servicespage
